// react
import {
    React,
    useState,
    useEffect,
} from 'react';

// third-party
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { HiChevronRight } from 'react-icons/hi2';

import { getData } from '../../services/fetch-service';

function SliderSidebar(props) {
    const { locale, location } = props;
    const [Sidebar, setSidebar] = useState([]);
    const [name, setName] = useState();
    useEffect(() => {
        getData(`SideBar/GetMenus?Gjuha=${locale}&LocationMenuID=3`).then((response) => {
            setSidebar(response.data);
            setName(response.data[0].menuLocationName);
        });
    }, []);

    const sdiebarList = Sidebar.map((item, index) => {
        return (
            <li key={index}>
                <HiChevronRight className="sidebar-arrow" />
                <Link to={item.url}>{item.pageName}</Link>
            </li>
        );
    });

    return (
        <div className={`sidebar-slider--${location}`}>
            <h1 className="slider-sidebar-title">{name}</h1>
            <ul className="links-slider">
                {sdiebarList}
            </ul>

        </div>

    );
}

SliderSidebar.propTypes = {
    // layout: PropTypes.oneOf(['default', 'about']),
    locale: PropTypes.string,
    // location: PropTypes.oneOf(['blog', 'shop']),
};

SliderSidebar.defaultProps = {
    // location: 'blog',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(SliderSidebar);
